import React from 'react';

import styled from 'styled-components';

import GroupsCreateButton from './create/GroupsCreateButton';

const Container = styled.div`
  display: flex;
`;

const GroupsActions = () => {
  return (
    <Container>
      <GroupsCreateButton />
    </Container>
  );
};

export default GroupsActions;
